export const auth = {
  // Login
  login: '登录',
  loginTitle: '欢迎回来',
  loginSubtitle: '登录到您的账户',
  email: '电子邮件',
  password: '密码',
  forgotPassword: '忘记密码？',
  noAccount: '还没有账户？',
  signUp: '注册',
  loginButton: '登录',
  loggingIn: '登录中...',
  
  // Register
  register: '注册',
  registerTitle: '创建账户',
  registerSubtitle: '今天加入 MakanTak',
  fullName: '全名',
  confirmPassword: '确认密码',
  haveAccount: '已有账户？',
  signIn: '登录',
  registerButton: '创建账户',
  registering: '创建账户中...',
  agreeToTerms: '注册即表示您同意我们的',
  termsOfService: '服务条款',
  and: '和',
  privacyPolicy: '隐私政策',
  
  // Forgot Password
  forgotPasswordTitle: '重置密码',
  forgotPasswordSubtitle: '输入您的电子邮件以接收重置说明',
  sendResetLink: '发送重置链接',
  sending: '发送中...',
  backToLogin: '返回登录',
  resetEmailSent: '重置邮件已发送！请查看您的收件箱。',
  
  // Reset Password
  resetPasswordTitle: '设置新密码',
  resetPasswordSubtitle: '输入您的新密码',
  newPassword: '新密码',
  resetPasswordButton: '重置密码',
  resetting: '重置中...',
  passwordResetSuccess: '密码重置成功！',
  
  // Validation
  emailRequired: '电子邮件为必填项',
  passwordRequired: '密码为必填项',
  nameRequired: '全名为必填项',
  passwordsNotMatch: '密码不匹配',
  invalidEmail: '无效的电子邮件地址',
  passwordTooShort: '密码必须至少 6 个字符',
};
